import { lazy } from "react";
import { Navigate, Outlet } from "react-router-dom";
// auth
import { GuestGuard } from "src/auth/guard";
// routes
import { paths } from "src/routes/paths";
// layouts
import AuthModernLayout from "src/layouts/auth/modern";

// ----------------------------------------------------------------------

// JWT
const JwtLoginPage = lazy(() => import("src/pages/auth/login"));
const JwtRegisterPage = lazy(() => import("src/pages/auth/register"));
const JwtForgotPasswordPage = lazy(() => import("src/pages/auth/forgot-password"));
const JwtNewPasswordPage = lazy(() => import("src/pages/auth/new-password"));

// ----------------------------------------------------------------------

export const authRoutes = [
    {
        path: "/",
        element: (
            <GuestGuard>
                <AuthModernLayout>
                    <Outlet />
                </AuthModernLayout>
            </GuestGuard>
        ),
        children: [
            { path: "", element: <Navigate to={ paths.auth.login } replace /> },
            { path: "login", element: <JwtLoginPage />, index: true },
            { path: "signup", element: <JwtRegisterPage /> },
            { path: "forgot_password", element: <JwtForgotPasswordPage /> },
            { path: "reset_password", element: <JwtNewPasswordPage /> }
        ]
    }
];
